module.exports = __webpack_public_path__ + "img/galeria-forrageiras-1.90f1aaf3.jpg";